module.exports = __webpack_public_path__ + "img/bots.4137e198.svg";